import React from "react";

const NewsPostItem = ({ item }) => {
  return (
    <div className="post-item clearfix">
      {/* src={item.img} */}
      <img alt=""></img>
      <h4>
        <a href="#">{item.title}</a>
      </h4>
      <p>{item.subtitle}...</p>
    </div>
  );
};

export default NewsPostItem;
